import React, { Component } from 'react'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import EmailUpdateUI from './EmailUpdateUI.js'

class EmailUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      email: this.props.email,
      emailError: null,
    }
  }

  render() {
    return (
      <EmailUpdateUI
        context={this.props.context}
        // text
        messageList={this.props.messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        // state
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel} // added in ViewOrUpdateUI
        setErrorList={this.setErrorList}
        // email
        email={this.state.email}
        emailError={this.state.emailError}
        onEmailChange={this.onEmailChange}
        setEmailError={this.setEmailError}
      />
    )
  }

  UNSAFE_componentWillMount() {
  }

  onEmailChange = (event) => {
    this.setState({email: event.target.value})
  }

  setEmailError = (error) => {
    this.setState({emailError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    console.log('calling server')
    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      '/api/user/email',
      this.onSubmitCallback, {
        email: this.state.email,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'email':
            this.setEmailError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      this.props.onUpdateComplete(this.state.email)
      setTimeout(() => {
        this.props.onCancel()
      }, 3000)
    }
  }
}

export default EmailUpdateSF
